import React from 'react'
import DraggableTile from '../draggable-tile'
import Tile, { TileProps } from '../tile/Tile'

interface PlacedTileProps extends TileProps {
    id?: number
}

export default function PlacedTile(props: PlacedTileProps) {
    if (props.id) return <DraggableTile id={props.id} {...props} />

    return (
        <div>
            <Tile {...props} />
        </div>
    )
}